import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

export default function loginAware(WrappedComponent) {
  function ReloadingComponent(props) {
    const [state, setState] = useState(props);
    const { authentication } = props;

    useEffect(() => {
      const reloadData = async () => {
        const newState = await WrappedComponent.getInitialProps(props);
        setState(newState);
      };

      reloadData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authentication]);

    useEffect(() => {
      setState(props);
    }, [props]);

    return <WrappedComponent {...state} />;
  }

  ReloadingComponent.getInitialProps = props => {
    return WrappedComponent.getInitialProps(props);
  };

  const mapStateToProps = ({ authentication }) => ({
    authentication,
  });

  return connect(mapStateToProps)(ReloadingComponent);
}
